// extracted by mini-css-extract-plugin
export default {"tipsList":"A7NuVLk7I8kPUcRf44pO","description":"TGUYHW56b3KBggwwDNIT"};